import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import commonDatas  from '../../apps/CommonDatas'
import './Camera.css';

var isVideoLoaded = false;
var webCamWidth = 100;
var webCamHeight = 100;

export function Camera () {
  const location = useLocation();
  const navigate = useNavigate();
  let model = 0;
  let type = 0;
  if( location.state != null ){
    model = location.state.model;
    type = location.state.type;
  }

  let baseIsError = false;
  const maskObj = commonDatas.getMaskData(model);
  if( maskObj === null ){
    baseIsError = true;
  }
  const startMatchFlag = useRef(false);
  const [isStart, setIsStart] = useState(true);
  const [isError, setIsError] = useState(baseIsError);
  const [isLoading, setIsLoading] = useState(true);
  const [typeNo, setTypeNo] = useState(0);
  
  var depth = 4;
  var sizeWidth = 240, sizeHeight = 320;
  var filterSize = 240;
  var filterWidth = 240;
  const filterLeft = useRef(0);
  const filterTop = useRef(0);
  const videoWidth = useRef(0);
  const videoHeight = useRef(0);
  
  var dispElem    = document.createElement("canvas");
  const onStartPopupCloseClick = function(e){
    e.preventDefault();

    setIsStart(false);
    startMatchFlag.current = true;
  }
    
  useEffect(() => {
    setTypeNo(type);
    
    document.getElementsByTagName("html")[0].scrollTop = 0;
    document.body.scrollTop = 0;
    
    const bgmObj1 = document.getElementById("bgm1");
    const bgmObj2 = document.getElementById("bgm2");
    bgmObj1.pause();  
    bgmObj1.currentTime = 0;
    bgmObj2.pause();  
    bgmObj2.currentTime = 0;
    
    const handleWindowResize = function(){
      onResizeCameraProc();
    }
    const onResizeCameraProc = function(){

        var contentInner = document.getElementById("content_inner");
        var videoArea   = document.getElementById("video_area");
        var videoObj    = document.getElementById("video_obj");
        var videoElem   = document.getElementById("video_obj");
    
        videoObj.style.height = "auto";
        videoObj.style.width = "auto";
    
        var w, h, vw;
        h = document.body.clientHeight;
        document.querySelector(':root').style.setProperty('--content_height', h + "px");
          
        var margin;

        w = document.body.clientWidth;
        
        vw = w;
        videoArea.style.width = w + "px";
        videoArea.style.height = w + "px";
        videoArea.style.top = 0 + "px";
        if( isVideoLoaded ){
          webCamWidth = videoElem.videoWidth;
          webCamHeight = videoElem.videoHeight;
          if( webCamWidth > 0 && webCamHeight > 0){
              margin = ((3 * vw) - w) / 2;
        
              if( webCamWidth > webCamHeight ){
                  videoObj.style.height = (3 * vw) + "px";
                  videoObj.style.width  = (3 * vw * webCamWidth / webCamHeight) + "px";
        
                  videoObj.style.top = -margin + "px";
                  videoObj.style.left =  "-" + (margin + (videoObj.clientWidth - videoObj.clientHeight) / 2) + "px";
              }else{
                  videoObj.style.width = (3 * vw) + "px";
                  videoObj.style.height = (3 * vw * webCamHeight / webCamWidth) + "px";
        
                  videoObj.style.left = -margin + "px";
                  videoObj.style.top = "-" + (margin + (videoObj.clientHeight - videoObj.clientWidth) / 2) + "px";
              }
                
                
              if( webCamWidth < webCamHeight ){
                  videoWidth.current = filterSize;
                  videoHeight.current = videoWidth.current * webCamHeight / webCamWidth;
                    
                  filterTop.current = (videoHeight.current - filterSize) / 2;
                  filterLeft.current = 0; 
              } else {
                  videoWidth.current = filterSize * webCamWidth / webCamHeight;
                  videoHeight.current = filterSize;
                    
                  filterTop.current = 0;
                  filterLeft.current = (videoWidth.current - filterSize) / 2; 
              }
        
              dispElem.width  = videoWidth.current;
              dispElem.height = videoHeight.current;
          }
          contentInner.style.width =  w + "px";
        }
    }
  
    var videoElem   = document.getElementById("video_obj");
    if( maskObj !== null ){
        
        var ua = navigator.userAgent;
        if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0 ) {
          if( window.orientation % 180 !== 0 ){
            videoWidth.current = sizeHeight;
            videoHeight.current = sizeWidth;
            filterLeft.current = 40;
          }else{
            videoWidth.current = sizeWidth;
            videoHeight.current = sizeHeight;
            filterTop.current = 40;
          }
        } else {
          videoWidth.current = sizeHeight;
          videoHeight.current = sizeWidth;
          filterLeft.current = 40;
        }
        var pixels;
        var drawFlag = false;
    
        
         dispElem.width  = videoWidth.current;
        dispElem.height = videoHeight.current;
        
        var objMatchRate = 0.8;
        
        var filterList = [];
        var workList   = [];
        var pointList  = [];
        var filterImgList = [];
        var matchRate  = 0;
        var disMatchRate = 0;
        
        pointList = maskObj.point;

        if( maskObj.filter.length > 0 ){
            for( var i = 0;i < maskObj.filter.length;i++ ){
                var filterElem    = document.createElement("canvas");

                filterElem.width  = filterWidth;
                filterElem.height = filterSize;

                var canvalId = "#filter" + i + "_img";

                var filterImg = new Image();
                filterImg.canvasId = canvalId;
                filterImg.src = maskObj.filter[i];
                filterImgList.push( filterImg );

                filterList.push( filterElem );
                workList.push(new Array(filterWidth * filterSize));
            }
        }

        matchRate = maskObj.match;
        disMatchRate = maskObj.dis_match;

        const modelFrameObj = document.getElementById("model_frame");
        const fixedFrameObj = document.getElementById("fixed_frame");
        modelFrameObj.src = './images/model' + model + '_matching.png';
        fixedFrameObj.src = './images/model' + model + '_fixed.png';

        handleWindowResize();
        window.removeEventListener('resize', handleWindowResize);
        window.addEventListener('resize', handleWindowResize);
        
        const dp = function(x, y){
            return ( y * depth ) * filterWidth + x * depth;
        }
        const checkColor = function( br, bg, bb, x, y ){
            var p = dp(x, y);
            var r = pixels.data[p];
            var g = pixels.data[p + 1];
            var b = pixels.data[p + 2];
    
            var dr = Math.abs(br - r);
            var dg = Math.abs(bg - g);
            var db = Math.abs(bb - b);
    
            if((dr < 40) && (dg < 30) && (db < 30) ){
                return true;
            }
            return false;
        }
        const myDraw = function(){
            if( !drawFlag && videoElem.srcObject != null ){
                drawFlag = true;
                
                var dispCtx   = dispElem.getContext('2d');
                dispCtx.drawImage(videoElem, webCamWidth / 3, webCamHeight / 3, webCamWidth / 3, webCamHeight / 3, 0, 0, dispElem.width, dispElem.height);
                if( startMatchFlag.current ){
                    pixels = dispCtx.getImageData(filterLeft.current, filterTop.current, filterWidth, filterSize);
                    
                    var i, j, x, y;
                    var matchCount = 0;
        
                    for( i = 0;i < workList.length;i++ ){
                        var workObj = workList[i];
                        for( j = 0;j < workList[i].length;j++ ){
                            workObj[j] = 0;
                        }
        
                        var cx, cy;
                        if( i < pointList.length ){
                            cx = pointList[i].x;
                            cy = pointList[i].y;
                        }else{
                            cx = Math.floor(filterWidth / 2);
                            cy = Math.floor(filterSize / 2);
                        }
                        j = dp(cx, cy);
                        var br = pixels.data[j];
                        var bg = pixels.data[j + 1];
                        var bb = pixels.data[j + 2];
        
                        if((br === 0) && (bg === 0) && (bb === 0)){
                            break;
                        }
        
                        var ctx = filterList[i].getContext('2d');
        
                        ctx.drawImage(filterImgList[i], 0, 0, filterWidth, filterSize, 0, 0, filterWidth, filterSize);
                        var filterPixels = ctx.getImageData(0, 0, filterWidth, filterSize);
        
                        var matchFlag = 0;
                        var disMatchFlag = 0;
                        var mc = 0;
                        var dc = 0;
                        for( y = 0;y < filterSize;y++ ){
                            for( x = 0;x < filterWidth;x++ ){
                                j = dp( x, y );
                                var key = filterPixels.data[j];
        
                                if( key === 0 ){
                                    dc++;
                                    if( !checkColor( br, bg, bb, x, y )){
                                        disMatchFlag++;
                                    }
                                }else if( key === 255 ){
                                    mc++;
                                    if( checkColor( br, bg, bb, x, y )){
                                        matchFlag++;
                                    }
                                }
                            }
                        }
                        if( ( disMatchFlag / dc >= disMatchRate ) && ( matchFlag / mc >= matchRate ) ){
                            matchCount++;
                        }
                    }
                    if( matchCount / workList.length >= objMatchRate ){
                        onMatchModel();
                    }
                }
    
                drawFlag = false;
                requestAnimationFrame(myDraw);
            }
          }
          const onMatchModel = function(){

            startMatchFlag.current = false;
    
            var foundModelList = commonDatas.loadFoundList();
    
            var param = model.split("_");
            var gid = parseInt(param[0]) - 1;
            var oid = parseInt(param[1]) - 1;
            foundModelList[gid][oid] = true;
    
            commonDatas.setCookie( "found_model", JSON.stringify(foundModelList) );
            modelFrameObj.style.display = "none";
            fixedFrameObj.style.visibility = "visible";
            
            var cameraObj;
            cameraObj = document.getElementById("camera");
            cameraObj.classList.add("match");
    
            commonDatas.setCookie( "last_found_model", model );
            commonDatas.setCookie( "last_found_model_type", typeNo );
        }
        if ((navigator.mediaDevices) && (navigator.mediaDevices.getUserMedia)) {
            var settings;
            settings = {video: {
                facingMode: {
                    exact: "environment"
                }
            }};
            navigator.mediaDevices.getUserMedia(settings)
                .then(
                    function(stream) {
                        videoElem.srcObject = stream;
                        videoElem.onloadedmetadata = function(e){
    
                            webCamWidth = e.srcElement.videoWidth;
                            webCamHeight = e.srcElement.videoHeight;
    
                            isVideoLoaded = true;
                            onResizeCameraProc();
    
                            videoElem.play();
                            setIsLoading(false);
                        };
                        requestAnimationFrame(myDraw);
                    })
                .catch(function(err) {
                    settings = {video: true};
                    navigator.mediaDevices.getUserMedia(settings)
                    .then(
                        function(stream) {
                            videoElem.srcObject = stream;
                            videoElem.onloadedmetadata = function(e){
                                webCamWidth = e.srcElement.videoWidth;
                                webCamHeight = e.srcElement.videoHeight;
    
                                isVideoLoaded = true;
                                onResizeCameraProc();
                                
                                videoElem.play();
                                setIsLoading(false);
                            };
                            requestAnimationFrame(myDraw);
                        })
                    .catch(function(err) {
                        console.log(err);
                        setIsError(true);
                        setIsLoading(false);
                    });
                });
        }else{
              setIsError(true);
            setIsLoading(false);
        }
    }
    if( baseIsError ){
      navigate("/list");
    }
                
    return () => {
        window.removeEventListener('resize', handleWindowResize);		
        if( videoElem.srcObject != null ){
            const tracks = videoElem.srcObject.getTracks();
            tracks.forEach(track => {
              track.stop();
            });
        }
        videoElem.srcObject = null;
        document.documentElement.style.setProperty('--content_width', "100vw"); 
    }
  }, [maskObj, model, navigate, depth, dispElem, filterSize, filterWidth, baseIsError, sizeHeight, sizeWidth, type, typeNo])
  
  return (
    <>
      <div id="camera" className={typeNo === "2" ? "content_wrapper content_type2" : "content_wrapper content_type1"}>
        <div className="content_main_wrapper">
          <div id="video_area">
            <video id="video_obj" autoPlay playsInline></video>
          </div>
          <div className="image_area">
            <img id="model_frame" width="100%" alt="" />
            <img id="fixed_frame" width="100%" alt="" />
          </div>
          <div id="content_inner" className="content_inner">
            <div className="pt655 mb40">
              <div className="matching_arrow"><img src={typeNo === "2" ? "./images/match_arrow2.png" : "./images/match_arrow1.png"} width="100%" alt="" /></div>
              <div className="matching_label attention_inner_header">おっとっとをここにあわせてね</div>

              <div className="matched_label">
                <div className="mb15"><img src={"./images/label_model" + model + ".png"} width="80.4%" alt="ぴったりはまったね！" /></div>
                <div className="mb70"><img src={typeNo === "2" ? "./images/match_complete_text2.png" : "./images/match_complete_text1.png"} width="80.4%" alt="ぴったりはまったね！" /></div>
                <Link to="/fish" id="btn_movie" state={{model: model, type: type}}><img src="./images/btn_game.png" width="69.219%" alt="ゲームをはじめる" /></Link>
              </div> 
              <div className="attention_inner left">
                <ul>
                  <li className="infomation">室内外の環境光によって認識しづらい場合がございます</li>
                  <li className="infomation">割れている・欠けている菓子は形を読み取れない可能性がございます</li>
                  <li className="infomation">菓子色と背景の色が似ていると認識しづらい場合がございます。その場合は濃い色の背景の上で読み取りください</li>
                  <li className="infomation">端末のカメラによっては認識しづらい場合がございます</li>
                  <li className="infomation">形を読み込む際は、菓子を置いておこなってください</li>
                </ul>
              </div>
              <div className="btn_back"><Link to="/list"><img src="./images/btn_back.png" width="100%" alt="もどる" /></Link></div>
            </div>
            <div className="copyright"><img src={typeNo === "2" ? "./images/img_copyright2.png" : "./images/img_copyright1.png"} width="100%" alt="Copyright © MORINAGA & CO., LTD. All rights reserved." /></div>
            </div>
        </div>

        {isStart ? 
          <div id="start_popup" className="over_popup">
            <div className="pt175 mb85"><img src={typeNo === "2" ? "./images/popup1_image2.png" : "./images/popup1_image1.png"} width="50.9375%" alt="" /></div>
            <div className="mb90"><img src="./images/popup1_label.png" width="74.375%" alt="おっとっとにカメラをむけてシルエットにあわせてね" /></div>
            <div className="pb50"><a className="close_popup" href="/#" onClick={(e) => onStartPopupCloseClick(e)}><img src={typeNo === "2" ? "./images/btn_ok2.png" : "./images/btn_ok1.png" } width="74.844%" alt="わかった" /></a></div>
          </div>
            :
        null}
        {isError ? 
          <div id="error_popup" className="over_popup">
            <div className="pt175 mb70"><img src="./images/popup2_image.png" width="32.533%" alt="" /></div>
            <div className="mb30"><img src="./images/popup2_label1.png" width="54%" alt="もういちどやってみてね カメラの起動が確認できませんでした。" /></div>
            <div className="mb40">
              <img src="./images/popup2_label2.png" width="24.533%" alt="動作環境については" />
              <Link to="/"><img src="./images/popup2_label3.png" width="16.667%" alt="トップページ" /></Link>
              <img src="./images/popup2_label4.png" width="22.267%" alt="でご確認ください" />
            </div>
            <div><Link id="btn_error" to="/list"><img src={typeNo === "2" ? "./images/btn_back2.png" : "./images/btn_back1.png"} width="80.267%" alt="もどる" /></Link></div>
          </div>
            :
          null
        }
        {isLoading ? <div id="loading" className="overlay">
          <div className="loading_wrapper">
            <div className="loading_inner">
              <div className="sk-fading-circle">
                <div className="sk-circle1 sk-circle"></div>
                <div className="sk-circle2 sk-circle"></div>
                <div className="sk-circle3 sk-circle"></div>
                <div className="sk-circle4 sk-circle"></div>
                <div className="sk-circle5 sk-circle"></div>
                <div className="sk-circle6 sk-circle"></div>
                <div className="sk-circle7 sk-circle"></div>
                <div className="sk-circle8 sk-circle"></div>
                <div className="sk-circle9 sk-circle"></div>
                <div className="sk-circle10 sk-circle"></div>
                <div className="sk-circle11 sk-circle"></div>
                <div className="sk-circle12 sk-circle"></div>
              </div>
              <div className="loading_test">Now Loading</div>
            </div>
          </div>
        </div> : null}
      </div>
    </>
  );
};